import { useContext } from 'react';
import { SgDateUtil } from 'saga-modules';
import { TranslatorContext } from '@jutro/locale';
import { renderContentFromMetadata } from '@jutro/uiconfig';

import metadata from './SgEndorsementSummaryTile.metadata.json5';
import messages from '../SgEndorsementInfo.messages';

function SgEndorsementSummaryTile(props) {
    const {
        policy
    } = props;

    const translator = useContext(TranslatorContext);

    const overrides = {
        policyTileHeader: {
            content: policy.policyHeader.header
        },
        policyTileSubHeader: {
            visible: !!policy.policyHeader.subHeader,
            content: policy.policyHeader.subHeader
        },
        policyNumberValue: {
            content: policy.policyNumber
        },
        coverLevelLabel: {
            content: policy.isPrivateMotor ? translator(messages.CoverLevelLabel) : translator(messages.TypeLevelLabel)
        },
        coverLevelValue: {
            content: policy.coverLevel
        },
        startDateValue: {
            content: SgDateUtil.getDateWithFullMonthName(policy.effectiveDate)
        }
    };

    const resolvers = {};

    return (
        renderContentFromMetadata(metadata.componentContent, overrides, resolvers)
    );
}

export default SgEndorsementSummaryTile;
